module.exports = __webpack_public_path__ + "img/Rookie-1.5ee6d97d.png";